import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Spin } from 'antd';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Restringir acceso de operadores solo a sus páginas permitidas
  if (user.rol === 'operador') {
    const allowedPaths = ['/mis-servicios', '/mi-caja-chica'];
    if (!allowedPaths.includes(location.pathname) && location.pathname !== '/') {
      return <Navigate to="/mis-servicios" replace />;
    }
  }

  return children;
};

export default PrivateRoute;

